 <template>
  <div class="table-responsive">
    <dynamic-table :columns="committeeDictumsColumns"
                   :data="dictums"
                   :loading="loading"
                   class="table-hover"
                   empty-message="No se han emitido dictámenes.">
      <template v-slot:type.title="slotProps">
                          <span v-if="slotProps.row.type.title === 'Aprobado'"
                                class="badge badge-success">{{ slotProps.row.type.title }}</span>
        <span
          v-else-if="slotProps.row.type.title === 'No aprobado' || slotProps.row.type.title === 'Rechazado'"
          class="badge badge-subtle badge-danger">{{ slotProps.row.type.title }}</span>
        <span v-else
              class="badge badge-subtle badge-dark">{{ slotProps.row.type.title }}</span>
      </template>
  
      <template v-slot:dictum_date="slotProps">
        {{ slotProps.row.dictum_date }} hrs.
      </template>
      
      <template v-slot:actions="slotProps">
        <div class="list-group-item-figure align-items-start justify-content-center">
          <div class="dropdown">
            <button aria-expanded="false" class="btn btn-sm btn-icon btn-light"
                    data-toggle="dropdown">
              <i class="fa fa-fw fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" style="">
              <div class="dropdown-arrow mr-n1"></div>
              <button class="dropdown-item"
                      type="button"
                      @click="$emit('show-comments', slotProps.row.comments)">
                Ver comentarios del comité
              </button>
            </div>
          </div>
        </div>
      </template>
    </dynamic-table>
  </div>
</template>

<script>
  import DynamicTable from '../../ui/DynamicTable'
  import { mapActions, mapGetters } from 'vuex'
  
  export default {
    name: 'CommitteeDictums',
    components: {
      DynamicTable,
    },
    props: {
      amendment: Object,
      committee: Object,
    },
    data() {
      return {
        loading: true,
        committeeDictumsColumns: [
          {
            field: 'committee.name',
            title: 'Comité',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'type.title',
            title: 'Dictamen',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'dictum_date',
            title: 'Fecha de dictamen',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'actions',
            title: 'Acciones',
            tdClass: 'align-middle text-center',
            tdStyle: {},
            thClass: 'align-middle text-center',
            thStyle: {},
          },
        ],
      }
    },
    methods: {
      ...mapActions({
        getDictums: 'amendments/getDictums',
      }),
      
      openCommentsModal(comments) {
        this.comments = comments
        this.$refs['comments-modal'].open()
      },
      async load() {
        this.loading = true
        
        const { amendment, committee } = this
        
        await this.getDictums({
          amendment,
          committee,
        })
        
        this.loading = false
      },
    },
    computed: {
      ...mapGetters({
        dictums: 'amendments/dictums',
      }),
    },
    async mounted() {
      await this.load()
    },
  }
</script>
